import { createAsyncAction, } from 'typesafe-actions';

import * as types from './types';
import { CheckoutTermsType, } from 'api/repositories/CheckoutTerms';

export const fetchCheckoutTerms = createAsyncAction(
    types.FETCH_CHECKOUT_TERMS_REQUEST,
    types.FETCH_CHECKOUT_TERMS_SUCCEEDED,
    types.FETCH_CHECKOUT_TERMS_FAILED,
)<never, Array<CheckoutTermsType>, any>();
